import React, { Component } from "react";
import { connect } from "react-redux";
import "./header.scss";
import { Link, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCircle,
  faUserGraduate,
} from "@fortawesome/free-solid-svg-icons";
import { withRouter } from "react-router-dom";
import { RouteComponentProps } from "react-router";
import { AuthenticateService } from "../../security/login/authenticate.service";
import { Navbar, Nav } from "react-bootstrap";
import { ChangePasswordModal } from "../../security/modals/changepassword";

interface HeaderState {
  sidebar?: boolean;
  show?: boolean;
  forceChangePassword?: boolean;
  notifyPasswordChange?: boolean;
  headerLinks?: any[];
  sidebarLinks?: any[];
  bankImage?: string;
}

class HeaderComponent extends Component<
  RouteComponentProps<any> & any,
  HeaderState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      sidebar: false,
      show: false,
      forceChangePassword: false,
      notifyPasswordChange: false,
      headerLinks: [],
      sidebarLinks: [],
      bankImage: "-",
    };
  }

  logout() {
    AuthenticateService.clear();
    this.props.logout();
  }

  showUserManual() {
    window.open("/resources/usermanual.pdf", "_blank");
  }

  closeChangePasswordModal = () => {
    return this.setState({ show: false });
  };

  openChangePasswordModal = () => {
    this.closeSidebar();
    return this.setState({ show: true });
  };

  openSidebar = () => {
    this.setState({ sidebar: true });
  };

  closeSidebar = () => {
    this.setState({ sidebar: false });
  };

  componentDidMount() {
    document.addEventListener("click", this.handleClick);
    const user = AuthenticateService.getActiveUser();
    const headerLinks: any[] = AuthenticateService.getHeaderLinks();
    const sidebarLinks: any[] = AuthenticateService.getSidebarLinks();
    let bankId =
      user && user.accessibleTenantIds && user.accessibleTenantIds.length > 0
        ? user.accessibleTenantIds[0]
        : 1;
    if (bankId === 1) {
      bankId = 30000000;
    }
    const bankImage = "/images/banks/" + bankId + ".png";

    this.setState({
      headerLinks,
      sidebarLinks,
      bankImage,
      forceChangePassword: user ? user.passwordExpired : false,
      notifyPasswordChange: user
        ? user.notifyPasswordChangeOn &&
          new Date() >= new Date(user.notifyPasswordChangeOn)
        : false,
    });
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClick);
  }

  handleClick = (e: any) => {
    if (
      ["mySidebar", "userIcon", "userIconContainer", "bankImage"].indexOf(
        e.target.id
      ) === -1
    ) {
      this.closeSidebar();
    }
  };

  renderHeaderLinks() {
    const headerLinks: any[] = this.state.headerLinks || [];

    headerLinks.forEach((headerLink) => {
      if (headerLink.icon && headerLink.icon.substr(0, 1) !== "/") {
        headerLink.icon = "/" + headerLink.icon;
      }
    });

    return (
      <>
        {headerLinks.map((link: any, index: any) => {
          return (
            <Nav.Link
              as={NavLink}
              key={`headerlink-${index}`}
              to={link.link}
              title={link.caption}
              activeClassName="nav-link-active"
              className="mr-4 bottom-border nav-ellipsis"
            >
              <img
                alt=" "
                src={link.icon}
                width="30px"
                className="p-1"
                style={{
                  display:
                    link.icon && link.icon.length ? "inline-block" : "none",
                }}
              />
              {link.caption}
            </Nav.Link>
          );
        })}
      </>
    );
  }

  renderSidebarLinks() {
    const sidebarLinks: any[] = this.state.sidebarLinks || [];
    return (
      <>
        {sidebarLinks.map((link: any, index: any) => {
          return (
            <Link
              to={link.link}
              key={`sidebarlink-${index}`}
              onClick={this.closeSidebar}
            >
              <img alt=" " src={link.icon} width="30px" className="p-1" />
              {link.caption}
            </Link>
          );
        })}
      </>
    );
  }

  render() {
    const user = AuthenticateService.getActiveUser();
    const show = this.state.show;
    const forceChangePassword = this.state.forceChangePassword;
    const notifyPasswordChange = this.state.notifyPasswordChange;
    const bankImage = this.state.bankImage;

    return (
      <div className={user ? "header-background-color" : ""}>
        <Navbar collapseOnSelect expand="md" className="header-margin-reset">
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            className={user ? "" : "display-none"}
          />
          <Navbar.Brand
            href="/"
            className="mr-xl-5 pr-xl-5 mr-lg-3 margin-right-auto"
          >
            <img
              className="logo"
              alt="AFS"
              src="/images/Logo-AFS-ProSight.png"
            />
          </Navbar.Brand>
          <div
            className={
              notifyPasswordChange
                ? "show d-block d-sm-none"
                : "hide d-block d-sm-none"
            }
          >
            <img
              src="/images/Password-Change-Red.png"
              alt="change_password_navbar"
              width="30px"
              className="p-1 mr-md-4 blink"
              onClick={this.openChangePasswordModal}
            />
          </div>
          <Nav
            className={
              user ? "show d-block d-md-none" : "hide d-block d-md-none"
            }
            id="userIcon"
          >
            <Nav.Link
              href="#"
              id="userIcon"
              className="d-block d-md-none"
              onClick={this.openSidebar}
            >
              <FontAwesomeIcon
                id="userIcon"
                className="user-info-icon"
                icon={faUserCircle}
                style={{ fontSize: 50 }}
                color="#fff"
              />
            </Nav.Link>
          </Nav>
          <Navbar.Collapse
            id="responsive-navbar-nav"
            className="navbar-link-custom"
          >
            <Nav activeKey={this.props.location.pathname} className="mr-auto">
              {this.renderHeaderLinks()}
            </Nav>
          </Navbar.Collapse>
          <div
            className={
              notifyPasswordChange
                ? "show d-none d-md-block"
                : "hide d-none d-md-block"
            }
          >
            <img
              src="/images/Password-Change-Red.png"
              alt="change_password_navbar"
              width="30px"
              className="p-1 mr-md-4 blink"
              onClick={this.openChangePasswordModal}
            />
          </div>
          <Nav
            className={
              user ? "show d-none d-md-block" : "hide d-none d-md-block"
            }
          >
            <Nav.Link
              href="#"
              id="userIcon"
              className="user-profile d-none d-md-block"
              onClick={this.openSidebar}
            >
              <div id="userIconContainer">
                <div
                  id="userIconContainer"
                  className="user-info-icon-container"
                >
                  <FontAwesomeIcon
                    id="userIcon"
                    className="user-info-icon"
                    icon={faUserCircle}
                    color="#fff"
                  />
                  <div
                    id="userIcon"
                    title={user ? user.name : ""}
                    className="align-self-center pl-2 user-info-name"
                  >
                    {user ? user.name : ""}
                  </div>
                </div>
                <div id="userIconContainer" className="user-info-bank">
                  <img id="bankImage" src={bankImage} alt=" " height="30px" />
                </div>
              </div>
            </Nav.Link>
          </Nav>
        </Navbar>
        <div
          id="mySidebar"
          className={this.state.sidebar ? "sidebar sidebar-open" : "sidebar"}
        >
          <div className="user-profile" onClick={this.closeSidebar}>
            <div id="userIconContainer">
              <div id="userIconContainer" className="user-info-icon-container">
                <FontAwesomeIcon
                  id="userIcon"
                  className="user-info-icon"
                  icon={faUserCircle}
                />
                <div
                  id="userIcon"
                  title={user ? user.name : ""}
                  className="align-self-center pl-2 user-info-name"
                >
                  {user ? user.name : ""}{" "}
                </div>
              </div>
              <div id="userIconContainer" className="user-info-bank">
                <img id="bankImage" src={bankImage} alt=" " height="30px" />
              </div>
            </div>
          </div>
          {this.renderSidebarLinks()}
          <Link
            to="/"
            onClick={() => {
              this.showUserManual();
            }}
          >
            <FontAwesomeIcon
              id="userIcon"
              className="user-info-icon user-guide-icon"
              icon={faUserGraduate}
            />
            User Guide
          </Link>
          <Link to="#" onClick={this.openChangePasswordModal}>
            <img
              src="/images/change_password_black.png"
              alt="change_password_navbar"
              width="30px"
              className="p-1"
            />
            Change Password
          </Link>
          <Link
            to="/"
            onClick={() => {
              this.logout();
            }}
          >
            <img
              src="/images/logout.png"
              alt="logout_navbar"
              width="30px"
              className="p-1"
            />
            Logout
          </Link>
        </div>
        <ChangePasswordModal
          forceChangePassword={forceChangePassword}
          show={show}
          userId={user ? user.userId : ""}
          closeChangePasswordModal={this.closeChangePasswordModal}
          logout={() => this.logout()}
        />
      </div>
    );
  }

  static properties = (state: any) => {
    return {};
  };

  static dispatchers = (dispatch: any) => {
    return {
      logout: (payload: any) => {
        dispatch({ type: "UNAUTHENTICATED", payload });
      },
    };
  };
}

export const Header = connect(
  HeaderComponent.properties,
  HeaderComponent.dispatchers
)(withRouter(HeaderComponent));
